// Size/color variant rows can put their SKU in front of the product SKU
// (witch-mat-100) instead of after it (mat-100-witch, the default). The flag
// rides on each variant so the backend builds the same SKU Konnektive gets.
const isSkuPrefix = (rows, value) => {
  const sku = String(value ?? "").trim();

  return sku !== "" && Boolean(rows?.find((row) => String(row?.value ?? "").trim() === sku)?.variant_sku_prefix);
};

export const withVariantSkuPrefixes = (variants, productData) =>
  variants.map((variant) => ({
    ...variant,
    ...(isSkuPrefix(productData?.product_size_variants, variant?.size) && { sizeSkuPrefix: true }),
    ...(isSkuPrefix(productData?.product_color_variants, variant?.color) && { colorSkuPrefix: true }),
  }));
